import { CSSProperties, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../API";
import { iPrintSchedule, iSFScheduleLine } from "../interfaceSFClient";

import { dateFormatter, dateShortFormatter, euros } from "../util";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectClassicLinks, setPrintSchedule, setTitle } from "../app/appSlice";

import Loader from "../components/Loader";

import './CreateSchedule.css';

interface iCreateScheduleRow {
    data: iSFScheduleLine;
    checked: boolean;
    toggleRow: () => void;
}

function CreateScheduleRow({ data, checked, toggleRow }: iCreateScheduleRow) {

    const { Uhrzeit, Fallnummer, OALA, Geburtsdatum, Geschlecht, Name, Bemerkungen, OffenerBetrag } = data;

    const rowS = [Uhrzeit, Fallnummer, OALA, dateShortFormatter.format(new Date(Geburtsdatum)), Geschlecht,
        Name.replaceAll(" ", "&nbsp;"), Bemerkungen, OffenerBetrag > 0 ? euros(OffenerBetrag) : "-"];

    const classicCookie = useAppSelector(selectClassicLinks);

    const urlAccount = classicCookie ?
        `https://d24000000xrg4eac.my.salesforce.com/` + data.KundeId :
        `https://d24000000xrg4eac.lightning.force.com/lightning/r/Account/${data.KundeId}/view`;

    return (
        <tr>
            <td><input type="checkbox" checked={checked} onChange={toggleRow} /></td>
            {rowS.map((td, i) => {
                let fontSize = "inherit";
                if (i === 12 && typeof td === "string" && td.length > 20) {
                    fontSize = Math.round(100 - td.length / 2.5) + "%"
                }
                const style: CSSProperties = {
                    fontSize
                }
                if (i === 5) return (<td key={i} style={style}>
                    <a href={urlAccount} target="_blank" rel="noreferrer" dangerouslySetInnerHTML={{ __html: td || "" }} />
                </td>);
                else return (
                    <td key={i} style={style} dangerouslySetInnerHTML={{ __html: td || "" }} />
                );
            })}
        </tr>
    );
}

export default function CreateSchedule() {

    const { bffid } = useParams();

    const dispatch = useAppDispatch();

    const addDays = [1, 1, 1, 1, 1, 3, 2];
    const initialDate = new Date(new Date().getTime() + addDays[new Date().getDay()] * 24 * 3600 * 1000);

    const [time, setTime] = useState<string>(initialDate.toISOString().substring(0, 10));
    const [bffName, setBffName] = useState<string>("");
    const [med1, setMed1] = useState<string>("");
    const [psy1, setPsy1] = useState<string>("");
    const [kunden, setKunden] = useState<iSFScheduleLine[] | null>(null);
    const [checked, setChecked] = useState<boolean[]>([]);

    useEffect(() => {
        dispatch(setTitle("Arbeitsplan"));
    }, [dispatch]);

    useEffect(() => {
        setKunden(null);
    }, [time]);

    function updatePrintSchedule() {
        if (kunden === null || kunden.length === 0) return;
        const checkedClients = kunden.filter((_, i) => checked[i]);
        const blankClient: iSFScheduleLine = {
            Id: "",
            Fallnummer: "",
            OALA: "",
            KundeId: "",
            Geburtsdatum: "",
            Geschlecht: "",
            Name: "&nbsp;",
            OffenerBetrag: 0
        };
        for (let i = 0; i < 3; i++) checkedClients.push(blankClient);
        const printschedule: iPrintSchedule = {
            time, bffName, med1, psy1, kunden: checkedClients
        };
        dispatch(setPrintSchedule(printschedule));
    }

    useEffect(() => {
        updatePrintSchedule();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checked]);

    function defaultChecked(remarks: string) {
        if (remarks.toLocaleLowerCase().includes("kommt nicht")) return false;
        if (remarks.toLocaleLowerCase().includes("kann nicht")) return false;
        if (remarks === "falsch") return false;
        return true;
    }

    useEffect(() => {
        async function load() {
            const reply = await api.loadSchedule(bffid!, new Date(time!).getTime());
            if (reply.success) {
                setBffName(reply.bff.Name);
                setMed1(reply.bff.Mediziner1);
                setPsy1(reply.bff.Psychologe1);
                setKunden(reply.kunden);
                const checked = new Array(reply.kunden.length).fill(true).map((_, i) => defaultChecked(reply.kunden[i].Bemerkungen || ""));
                setChecked(checked);
            }
        }
        if (bffid && time) {
            load();
        }
    }, [bffid, time]);

    function toggleRow(i: number) {
        setChecked(checked.map((c, ci) => ci === i ? !c : c));
    }

    return (
        <div className="CreateSchedule">
            <p>
                Datum wählen: <input type="date" value={time} onChange={e => setTime(new Date(e.target.value).toISOString().substring(0, 10))} />
            </p>
            <h1>Arbeitsplan für {bffName} vom {dateFormatter.format(new Date(time))}</h1>
            <h2>Mediziner: <strong>{med1}</strong>, Psychologe: <strong>{psy1}</strong> </h2>
            {kunden === null && <Loader />}
            {kunden !== null && kunden.length === 0 && <h3>** Keine Einträge **</h3>}
            {kunden !== null && kunden.length > 0 &&
                <>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th rowSpan={2}>Uhrzeit</th>
                                <th rowSpan={2}>Fallnummer</th>
                                <th rowSpan={2}>OA/LA</th>
                                <th rowSpan={2}>Geb.Datum</th>
                                <th rowSpan={2}>m/w</th>
                                <th rowSpan={2}>Name des KD</th>
                                <th rowSpan={2}>Bemerkungen</th>
                                <th rowSpan={2}>Offener Betrag</th>
                            </tr>
                        </thead>
                        <tbody>
                            {kunden.map((line, i) => <CreateScheduleRow key={line.Id} data={line} checked={checked[i]} toggleRow={() => toggleRow(i)} />)}
                        </tbody>
                    </table>
                    <p>
                        <Link to={"/printschedule"} ><button className="Text">Arbeitsplan drucken</button></Link>
                    </p>
                </>
            }

        </div>
    );
}